var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"top-content-container"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{key:_vm.$route.path,attrs:{"search":_vm.search}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }